module.exports = __webpack_public_path__ + "img/cajon_de_managers.731687eb.gif";